import { Link } from 'react-router-dom';
import './AmbassadorRules.css';

const UPDATED_AT = '22 апреля 2026';

export default function AmbassadorRules() {
  return (
    <div className="ambassador-rules-page">
      <div className="container">
        <div className="ambassador-rules-content">
          <div className="ambassador-rules-header">
            <h1 className="ambassador-rules-title">Правила программы "Амбассадор Площадки"</h1>
            <p className="ambassador-rules-updated">Дата последнего обновления: {UPDATED_AT}</p>
          </div>

          <section className="ambassador-rules-section ambassador-rules-brief">
            <h2>Короткая версия</h2>
            <ol>
              <li>Опубликуйте публичное видео о тренировках с Площадкой в любой соцсети.</li>
              <li>Укажите "Площадка" в видео или описании.</li>
              <li>Отправьте ссылку в чат с аккаунтом поддержки +70000000000 в приложении.</li>
              <li>За принятое видео присваиваем статус "Амбассадор".</li>
              <li>
                Выплата за просмотры одного видео:
                <ul>
                  <li>100 000+ просмотров — 5 000 руб.</li>
                  <li>500 000+ просмотров — 10 000 руб.</li>
                  <li>1 000 000+ просмотров — 20 000 руб.</li>
                </ul>
              </li>
              <li>Выплачивается максимальный достигнутый порог (пороги не суммируются).</li>
              <li>Накрутка просмотров запрещена и ведет к отказу в выплате.</li>
            </ol>
          </section>

          <section className="ambassador-rules-section">
            <h2>Полная версия</h2>

            <h3>1. Кто может участвовать</h3>
            <ul>
              <li>Участник — пользователь с активным аккаунтом в приложении "Площадка".</li>
              <li>Один человек участвует с одного аккаунта.</li>
              <li>Организатор вправе запросить подтверждение личности для выплаты.</li>
            </ul>

            <h3>2. Что считается валидным видео</h3>
            <ul>
              <li>Видео должно быть оригинальным и опубликованным участником.</li>
              <li>Видео должно быть публичным и доступным на момент проверки.</li>
              <li>В видео или описании должно быть упоминание "Площадка".</li>
              <li>Запрещен контент, нарушающий закон, права третьих лиц и правила платформ.</li>
            </ul>

            <h3>3. Как подать заявку</h3>
            <ul>
              <li>Отправьте ссылку на видео во внутренний чат с администратором (от которого получили сообщение) или в Telegram @encodedcookie.</li>
              <li>В одном сообщении укажите ссылку, площадку публикации и дату публикации.</li>
              <li>Один ролик учитывается один раз. Повторные заявки на тот же ролик отклоняются.</li>
            </ul>

            <h3>4. Награды и выплаты</h3>
            <ul>
              <li>После модерации валидного ролика участнику присваивается статус "Амбассадор".</li>
              <li>Выплаты по порогам: 100k — 5 000 руб., 500k — 10 000 руб., 1M — 20 000 руб.</li>
              <li>По одному видео выплачивается только один, максимальный, достигнутый порог.</li>
              <li>Детали выплаты и реквизиты запрашиваются после подтверждения результата.</li>
            </ul>

            <h3>5. Как фиксируются просмотры</h3>
            <ul>
              <li>Просмотры фиксируются на дату проверки, назначенную организатором.</li>
              <li>Видео и счетчик просмотров должны быть доступны на момент проверки.</li>
              <li>Организатор вправе запросить дополнительные подтверждения статистики.</li>
            </ul>

            <h3>6. Антифрод и причины отклонения</h3>
            <ul>
              <li>Запрещены боты, биржи трафика и любые искусственные способы накрутки.</li>
              <li>При подозрении на накрутку заявка переводится в дополнительную проверку.</li>
              <li>Подтвержденная накрутка = отказ в выплате и исключение из программы.</li>
            </ul>

            <h3>7. Сроки обработки</h3>
            <ul>
              <li>Первичная модерация: до 5 рабочих дней.</li>
              <li>Дополнительная проверка (если нужна): до 10 рабочих дней.</li>
              <li>Выплата после подтверждения порога: до 10 рабочих дней.</li>
            </ul>

            <h3>8. Изменение правил</h3>
            <p>
              Организатор может обновлять правила программы. Актуальная версия всегда публикуется на этой странице.
              Участие в программе означает согласие с действующей версией правил.
            </p>
          </section>

          <div className="ambassador-rules-footer">
            <Link to="/" className="btn btn-primary">Вернуться на главную</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
